import { useState } from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { Zoom } from 'react-awesome-reveal';
import { Icon } from '@iconify/react';
import minusIcon from '@iconify-icons/mdi/minus';
import sectionConstants from '../../constants/SectionConstants';
import '../styles/Section8.scss';

const Section8 = () => {
  const [showContent, setShowContent] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);

  const handleIconClick = (content: any) => {
    if (selectedContent === content) {
      setSelectedContent(null);
      setShowContent(!showContent);
    } else {
      setSelectedContent(content);
      setShowContent(true);
    }
  };

  const faq = [
    {
      id: '1',
      content: sectionConstants.WhychooseAyka,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq1
    },
    {
      id: '2',
      content: sectionConstants.Howdoesitwork,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq2
    },
    {
      id: '3',
      content: sectionConstants.CanItrackvehiclesinrealtime,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq3
    },
    {
      id: '4',
      content: sectionConstants.HowcanImonitordriver,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq4
    },
    {
      id: '5',
      content: sectionConstants.Whatfleetmanagementsolutions,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq5
    },
    {
      id: '6',
      content: sectionConstants.Whatarethebenefitsofchoosing,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq6
    },
    {
      id: '7',
      content: sectionConstants.Whatfactorsshouldbeconsidered,
      icon: 'mingcute:add-line',
      para: sectionConstants.Faq7
    }
  ];

  return (
    <Box className='Section8'>
      <Zoom>
        <Stack alignItems='center' justifyContent='center' mb={4}>
          {sectionConstants.FrequentlyAskedQuestions}
        </Stack>
        {faq.map(item => (
          <Container  className='Section8-bg'>
            <Stack
              className='Section8-content'
              direction='row'
              justifyContent='space-between'
              alignItems='center'
            >
              <Typography pl={2} className='Section8-content-data'>{item.content}</Typography>
              <Icon
                icon={selectedContent === item.content ? minusIcon : item.icon}
                className='Section8-icon'
                onClick={() => handleIconClick(item.content)}
              />
            </Stack>
            {showContent && selectedContent === item.content && (
              <Typography ml={2} className='section8-para'>
                {item.para}
              </Typography>
            )}
          </Container>
        ))}
      </Zoom>
    </Box>
  );
};

export default Section8;
